export default "/fonts/vendor/@mdi/materialdesignicons-webfont.woff2?f97b38e4afe65388b4f0d620da4689de";